module.exports = __webpack_public_path__ + "img/coding-disabled.aaa4502c.svg";